import React from "react";
import { RCCGrid } from "react-common-components";
import { v4 } from "uuid";
import Photo from "../../Photo";
import { IComponentUserColumn } from "./interface";

const UserColumn: React.FC<IComponentUserColumn> = ({
	name,
	image,
	imageOnly,
	list,
	hover = true
}) => {
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	return(
		<RCCGrid 
			item
			container
			alignItems="center"
			justifyContent="flex-start"
		>
			{
				list
					? 
					(<>
						{
							list.map((user) => (
								<div key={v4()}>
									<Photo 
										styleInline={imageOnly ? "margin: 0px" : "margin: 0 5px"}
										hover={hover}
										name={user.name || " "}
										link={user.image && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${user.image}`}
										width={30}
										height={30}
									/>
									<span>
										{imageOnly ? "" : user.name || " "}
									</span>
								</div>
							))
						}
					</>) 
					: 
					(<>
						<Photo 
							hover={hover}
							name={name || " "}
							link={image && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${image}`}
							width={30}
							height={30}
						/>
						<span>
							{imageOnly ? "" : name || " "}
						</span>
					</>)
			}
			
		</RCCGrid>
	);};

export default UserColumn;
